import { FalloutCharacter, FalloutCharacterStatus, FalloutEquippedWeapon, FalloutStat, FalloutStatBlock, FalloutWeaponTest, FalloutWeaponType, PromptTakeAction } from "../Data/Response";
import styles from './EquippedWeaponView.module.scss';
import MeterView from "./MeterView";


interface EquippedWeaponViewArgs {
    weapon: FalloutEquippedWeapon;
    isYou: boolean;
    character: FalloutCharacter;
    openFire: () => void;
    brawl: () => void;
    actionPrompt?: PromptTakeAction;
}

const EquippedWeaponView: React.FC<EquippedWeaponViewArgs> = args => {
    const w = args.weapon;
    const c = args.character;

    const isRanged = args.weapon.range;
    const characterIsActive = args.character.state.status === "active";
    const showButton = characterIsActive && args.isYou;

    const characterActions = args.actionPrompt?.charactersAvailableActions[args.character.id];
    const openFireEnabled = (characterActions && characterActions.find(a => a.weaponId === args.weapon.id));

    return <li className={styles.equippedWeaponView}>
        {showButton && (
            isRanged
                ? <button
                    disabled={!openFireEnabled}
                    onClick={e => {
                        e.preventDefault();
                        args.openFire();
                    }}>Open Fire!</button>
                : <button
                    disabled={!openFireEnabled}
                    onClick={e => {
                        e.preventDefault();
                        args.brawl();
                    }}>Brawl!</button>
        )}
        {!showButton && <h2 className={styles.actionName}>{isRanged ? "Open Fire" : "Brawl"}</h2>}

        <h3 className={styles.name}>{args.weapon.name}</h3>
        <ul className={styles.stats}>
            <li>
                <h3>Dice</h3>
                <MeterView current={args.weapon.test.dice} isDice={true} />
            </li>
            <li>
                <h3>Less Than</h3>
                {GetTestNumber(args.weapon.test.skill, args.character.stats) + 1}
            </li>
            {args.weapon.range && <li>
                <h3>Range</h3>
                {args.weapon.range}
            </li>}
        </ul>

        <div>
            <h3>Traits</h3>
            <ul className={styles.traitsList}>
                {w.traits.map(t => {
                    return <li>{t.fullName}</li>
                })}
            </ul>
        </div>

        <div>
            <h3>Critical Effects</h3>
            <ul className={styles.traitsList}>
                {w.criticalEffects.map(t => {
                    return <li>{t.fullName}</li>
                })}
            </ul>
        </div>
    </li >
}

const GetTestNumber = (stat: FalloutStat, statBlock: FalloutStatBlock) => {
    switch (stat) {
        case "agility": return statBlock.agility;
        case "perception": return statBlock.perception;
        case "strength": return statBlock.strength
        default: return 0;
    }
}

export default EquippedWeaponView;